import styled from '@emotion/styled';
import { Container } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const PageContainer = styled(Container)`
  margin-bottom: 100px;
  ${mediaQuery('small')} {
    margin-bottom: 50px;
  }
`;

